import clsx from 'clsx';

export interface ToastProps {
  message: string;
  variant?: 'success' | 'error' | 'info';
  onClose: () => void;
}

/** A single toast notification. Rendered by `ToastContext`'s toast stack. */
export function Toast({ message, variant = 'success', onClose }: ToastProps) {
  return (
    <div
      role="status"
      className={clsx(
        'pointer-events-auto flex items-center gap-3 max-w-md w-full rounded-lg shadow-lg px-4 py-3 font-body text-sm',
        variant === 'error' ? 'bg-danger text-white' : 'bg-ink text-white',
      )}
    >
      <span className="flex-1">{message}</span>
      <button
        type="button"
        onClick={onClose}
        aria-label="Dismiss notification"
        className="min-h-0 h-6 w-6 flex items-center justify-center rounded text-white/80 hover:text-white"
      >
        &times;
      </button>
    </div>
  );
}
